// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"159":"832110ba","542":"2161624a","814":"9e501278"}[chunkId] + ".css";
};